module.exports = __webpack_public_path__ + "img/uploadBlack.19b4bfe4.svg";